export const SINGLETON_KEY = '__singleton__';
